import { useMemo } from "react";
import { useGetActiveUsers, useGetAllTeamMembers } from "../../../api/teams";
import type { User } from "../../../shared/types/user.type";
import { filterAssignableTeamMembers } from "./assignableTeamMembers.utils";

interface UseAssignableTeamMembersResult {
  data?: User[];
  isLoading: boolean;
}

export const useAssignableTeamMembers = (
  enabled = true
): UseAssignableTeamMembersResult => {
  const { data: teamMembers, isLoading: isTeamMembersLoading } =
    useGetAllTeamMembers(enabled);
  const { data: activeUsers, isLoading: isActiveUsersLoading } =
    useGetActiveUsers(enabled);

  const data = useMemo(() => {
    if (teamMembers === undefined || activeUsers === undefined) {
      return undefined;
    }

    const activeUserIds = new Set(
      activeUsers.items.map((user) => user.userId)
    );

    return filterAssignableTeamMembers(teamMembers, activeUserIds);
  }, [teamMembers, activeUsers]);

  return {
    data,
    isLoading: isTeamMembersLoading || isActiveUsersLoading,
  };
};
